/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

export function userUpdatedAction(payload) {
  return {
    type: "USER_UPDATED",
    payload,
  };
}

const defaultState = {
  fullName: "",
};

export function userProfileReducer(
  previousState = defaultState,
  { type, payload }
) {
  if (type === userUpdatedAction().type) {
    return {
      fullName: `${payload.firstName} ${payload.lastName}`,
    };
  }
  return previousState;
}
